import { Eye, Heart, Lightbulb, Target } from "lucide-react";
import { ContactSection } from "~/components/marketing/contact-section";
import { generateMetaTags, SITE_URL } from "~/lib/seo";

export function meta() {
	return generateMetaTags({
		title: "O nás – FirmIndex",
		description:
			"FirmIndex vznikl s vizí zpřístupnit finanční data o českých firmách každému. Poznejte náš příběh, hodnoty a tým nebo nám napište.",
		canonical: `${SITE_URL}/o-nas`,
	});
}

const values = [
	{
		icon: Target,
		title: "Přesnost",
		description:
			"Každý údaj prochází důkladnou kontrolou. Naše data pocházejí přímo z oficiálních registrů.",
	},
	{
		icon: Eye,
		title: "Transparentnost",
		description: "Věříme v otevřenost — jak v cenové politice, tak ve způsobu zpracování dat.",
	},
	{
		icon: Heart,
		title: "Jednoduchost",
		description:
			"Finanční data by měla být srozumitelná pro každého, nejen pro účetní a analytiky.",
	},
	{
		icon: Lightbulb,
		title: "Inovace",
		description:
			"Využíváme AI a moderní technologie, abychom vám přinesli víc než jen surová čísla.",
	},
];

export default function ONas() {
	return (
		<>
			{/* Header */}
			<section className="public-hero mx-3 mt-3 rounded-3xl px-6 pb-16 pt-16 sm:mx-4 lg:px-8 lg:pt-24">
				<div className="mx-auto max-w-4xl text-center">
					<h1 className="text-4xl font-extrabold tracking-tight text-text sm:text-5xl">O nás</h1>
					<p className="mx-auto mt-6 max-w-2xl text-lg text-muted leading-relaxed">
						FirmIndex vznikl s jednoduchou vizí — zpřístupnit finanční data o českých firmách
						každému, kdo je potřebuje. Ať už jste podnikatel, investor, nebo analytik.
					</p>
				</div>
			</section>

			{/* Story */}
			<section className="px-6 py-20 lg:px-8">
				<div className="mx-auto max-w-3xl">
					<h2 className="text-2xl font-bold text-text">Náš příběh</h2>
					<div className="mt-6 flex flex-col gap-4 text-muted leading-relaxed">
						<p>
							Všechno začalo frustrací. Při prověřování obchodních partnerů jsme museli procházet
							desítky různých registrů, stahovat PDF z justice.cz a ručně analyzovat účetní závěrky.
							Informace byly roztříštěné, zastaralé a těžko srovnatelné.
						</p>
						<p>
							V roce 2024 jsme se rozhodli, že to musí jít lépe. Vznikl FirmIndex — platforma, která
							agreguje data z veřejných registrů, obohacuje je o AI analýzu a prezentuje je v
							přehledné a srozumitelné podobě.
						</p>
						<p>
							Dnes FirmIndex pokrývá více než 500 000 českých firem a pomáhá tisícům uživatelů dělat
							lepší obchodní rozhodnutí.
						</p>
					</div>
				</div>
			</section>

			{/* Values */}
			<section className="px-6 py-20 lg:px-8">
				<div className="mx-auto max-w-7xl">
					<div className="text-center">
						<h2 className="text-3xl font-bold tracking-tight text-text">Naše hodnoty</h2>
						<p className="mx-auto mt-4 max-w-2xl text-muted">
							Principy, kterými se řídíme při vývoji produktu i komunikaci se zákazníky.
						</p>
					</div>
					<div className="mt-12 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
						{values.map((v) => (
							<div key={v.title} className="card-surface rounded-2xl p-6 text-center">
								<div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-lg bg-primary-50">
									<v.icon size={24} className="text-primary-600" />
								</div>
								<h3 className="text-lg font-semibold text-text">{v.title}</h3>
								<p className="mt-2 text-sm text-muted">{v.description}</p>
							</div>
						))}
					</div>
				</div>
			</section>

			{/* Founder */}
			<section className="px-6 py-20 lg:px-8">
				<div className="glass-panel-strong mx-auto max-w-3xl rounded-3xl px-6 py-12 text-center">
					<img
						src="/team/daniela-smelkova.png"
						alt="Daniela Šmelková"
						className="mx-auto h-32 w-32 rounded-full object-cover"
					/>
					<h3 className="mt-6 text-xl font-bold text-text">Daniela Šmelková</h3>
					<p className="text-muted">Founder & CEO</p>
					<a
						href="https://www.linkedin.com/in/smekova/"
						target="_blank"
						rel="noopener noreferrer"
						className="mt-3 inline-block text-sm text-primary-600 hover:underline"
					>
						LinkedIn
					</a>
				</div>
			</section>

			<ContactSection showHeading />
		</>
	);
}
